import { createSelector } from '@reduxjs/toolkit';

import { CompPropertyDataState, SubjectPropertyDataState } from '../../../types.ts';
import { selectPropertyDataEntities } from './propertyDataSelectors.ts';

export const selectSelectedSourcesEntities = createSelector(
  [selectPropertyDataEntities],
  (propertyDataEntities) =>
    Object.fromEntries(
      Object.entries(propertyDataEntities).map(([id, propertyDataEntity]) => {
        const { selectedSources } =
          id === 'subject'
            ? (propertyDataEntity as SubjectPropertyDataState).subjectData
            : (propertyDataEntity as CompPropertyDataState).compData;

        return [id, selectedSources];
      }),
    ),
);

export const selectSelectedSourcesById = createSelector(
  [selectSelectedSourcesEntities, (_state, id: string) => id],
  (selectedSourcesEntities, id) => selectedSourcesEntities[id],
);

export const selectAllSelectedSources = createSelector(
  [selectSelectedSourcesEntities],
  (selectedSourcesEntities) => Object.values(selectedSourcesEntities),
);
